let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cL4vz")).then(() => parcelRequire('3R1Ez'));